import React, { useState } from "react";
import * as Styled from "./styled";
import FuelGauge from "../FuelGauge";
import { db } from "../../db/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getAuth } from "firebase/auth";

type FieldType =
  | "text"
  | "number"
  | "date"
  | "select"
  | "textarea"
  | "file"
  | "checkbox"
  | "fuel";

export interface Field {
  name: string;
  label: string;
  type: FieldType;
  required?: boolean;
  options?: string[];
  $fullWidth?: boolean;
  placeholder?: string;
}

interface ComponentFormProps {
  title: string;
  fields: Field[];
  onSubmit: (data: Record<string, any>) => void;
  onCancel: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  initialData?: Record<string, any>;
  onChange?: (data: any) => void; 
}

const ComponentForm = ({
  title,
  fields,
  onSubmit,
  onCancel,
  submitLabel = "Salvar",
  cancelLabel = "Cancelar",
  initialData = {},
}: ComponentFormProps) => {
  const [extras, setExtras] = useState<Record<string, any>>(
  initialData?.extras || {}
);
  const [formData, setFormData] = useState<Record<string, any>>(() => {
    const data: Record<string, any> = {};


    fields.forEach((field) => {
      if (initialData?.[field.name] !== undefined) {
        data[field.name] = initialData[field.name];
      } else {
        if (field.type === "checkbox") data[field.name] = false;
        else if (field.type === "file") data[field.name] = undefined;
        else if (field.type === "fuel") data[field.name] = 50;
        else data[field.name] = "";
      }
    });

    return data;
  });

const findClientMotorcycle = async (nomeCliente: string) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) return null;

    const q = query(
      collection(db, "services"),
      where("userId", "==", user.uid),
      where("nomeCliente", "==", nomeCliente)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      return snapshot.docs[0].data();
    }

    return null;
  } catch (error) {
    console.error("Erro ao buscar cliente:", error);
    return null;
  }
};

const handleChange = async (name: string, value: any) => {
  const newData = {
    ...formData,
    [name]: value,
  };

  setFormData(newData);

  if (
    name === "nomeCliente" &&
    value.length > 2
  ) {
    const cliente = await findClientMotorcycle(value);

    if (cliente) {
      console.log("Cliente encontrado:", cliente);

      setFormData((prev) => ({
        ...prev,
        telefone: cliente.telefone || "",
        modeloMoto: cliente.modeloMoto || "",
        placa: cliente.placa || "",
        anoMoto: cliente.anoMoto || "",
      }));
    }
  }
};
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const dataToSubmit = {
    ...formData,
    extras,
  };
    onSubmit(dataToSubmit);
  };

const addExtraField = (fieldName: string) => {
  setExtras((prev) => ({
    ...prev,
    [fieldName]: [
      ...(prev[fieldName] || []),
      { produto: "", valor: "" },
    ],
  }));
};

  const handleExtraChange = (
  fieldName: string,
  index: number,
  key: string,
  value: string
  ) => {
    setExtras((prev) => {
      const updated = [...(prev[fieldName] || [])];

      updated[index] = {
        ...updated[index],
        [key]: value,
      };

      return {
        ...prev,
        [fieldName]: updated,
      };
    });
  }

  const removeExtraField = (fieldName: string, index: number) => {
    setExtras((prev) => {
      const updated = [...(prev[fieldName] || [])];
      updated.splice(index, 1);

      return {
        ...prev,
        [fieldName]: updated,
      };
    });
  }

  return (
    <Styled.Container>
      <Styled.ModalContent>

        <h2>{title}</h2>

        <Styled.Form onSubmit={handleSubmit}>

          {fields.map((field) => (

            <Styled.FormGroup key={field.name} $fullWidth={field.$fullWidth}>

              <label htmlFor={field.name}>
                {field.label}
                {field.required && " *"}
              </label>
              {field.type === "select" && (
            <>
              <select
                id={field.name}
                value={
                  field.options?.includes(formData[field.name])
                    ? formData[field.name]
                    : formData[field.name]
                    ? "Outros"
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "Outros") {
                    handleChange(field.name, "");
                  } else {
                    handleChange(field.name, value);
                  }
                }}
                required={field.required}
              >
                <option value="">Selecione</option>

                {field.options?.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}

                {field.name === "tipoConserto" && (
                  <option value="Outros">Outros</option>
                )}
              </select>

            {field.name === "tipoConserto" &&
                (!field.options?.includes(formData[field.name]) ||
                  formData[field.name] === "") && (
                  <input
                    style={{ marginTop: 8 }}
                    type="text"
                    placeholder="Digite aqui"
                    value={formData[field.name] ?? ""}
                    onChange={(e) =>
                      handleChange(field.name, e.target.value)
                    }
                    required
                  />
                )}
              </>
            )}
              {/* TEXTAREA */}

              {field.type === "textarea" && (
                <textarea
                  id={field.name}
                  value={formData[field.name] ?? ""}
                  placeholder={field.placeholder}
                  onChange={(e) => {

                    const el = e.target as HTMLTextAreaElement;

                    el.style.height = "auto";
                    el.style.height = el.scrollHeight + "px";

                    handleChange(field.name, el.value);
                  }}
                />
              )}

              {/* FILE */}

              {field.type === "file" && (
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={async (e) => {
                      const files = Array.from(e.target.files || []);

                      if (!files.length) return;

                      const convertToBase64 = (file: any) => {
                        return new Promise((resolve, reject) => {
                          const reader = new FileReader();

                          reader.onloadend = () => resolve(reader.result);
                          reader.onerror = reject;

                          reader.readAsDataURL(file);
                        });
                      };

                      const base64Files = await Promise.all(
                        files.map((file) => convertToBase64(file))
                      );

                      handleChange(field.name, base64Files);
                    }}
                  />
                  )}

              {/* CHECKBOX */}


                {field.type === "checkbox" && (
                  <>
                    <input
                      id={field.name}
                      name={field.name}
                      type="checkbox"
                      checked={!!formData[field.name]}
                      placeholder={field.placeholder}
                      onChange={(e) => {
                        handleChange(field.name, e.target.checked);

                        if (
                          e.target.checked &&
                          !(extras[field.name]?.length > 0)
                        ) {
                          addExtraField(field.name);
                        }
                      }}
                    />

                    {formData[field.name] && (
                      <>
                        {(extras[field.name] || []).map(
                          (item: any, index: number) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 8,
                                marginTop: 8,
                                width: "100%",
                                flexWrap: "wrap",
                              }}
                            >
                              <Styled.TextArea
                                placeholder="Qual produto ou peça?"
                                value={item.produto}
                                onChange={(e: any) => {
                                  e.target.style.height = "13px";
                                  e.target.style.height = `${e.target.scrollHeight}px`;

                                  handleExtraChange(
                                    field.name,
                                    index,
                                    "produto",
                                    e.target.value
                                  );
                                }}
                              />

                              <input
                                type="text"
                                placeholder="Valor de compra?"
                                value={item.valorCompra || ""}
                                onChange={(e) => {
                                  let value = e.target.value;

                                  value = value.replace(/[^0-9.,]/g, "");

                                  handleExtraChange(
                                    field.name,
                                    index,
                                    "valorCompra",
                                    value
                                  );
                                }}
                              />

                              <input
                                type="text"
                                placeholder="Valor de venda?"
                                value={item.valorVenda || ""}
                                onChange={(e) => {
                                  let value = e.target.value;

                                  value = value.replace(/[^0-9.,]/g, "");

                                  handleExtraChange(
                                    field.name,
                                    index,
                                    "valorVenda",
                                    value
                                  );
                                }}
                              />

                              {/* BOTÃO + SOMENTE NO ÚLTIMO */}
                              {index ===
                                (extras[field.name] || []).length - 1 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    addExtraField(field.name)
                                  }
                                  style={{
                                    backgroundColor: "#078017",
                                    color: "#fff",
                                    border: "none",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    borderRadius: 4,
                                  }}
                                >
                                  +
                                </button>
                              )}

                              {/* BOTÃO - */}
                              {(extras[field.name] || []).length > 1 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    removeExtraField(
                                      field.name,
                                      index
                                    )
                                  }
                                  style={{
                                    backgroundColor: "#9c1e08",
                                    color: "#fff",
                                    border: "none",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    borderRadius: 4,
                                  }}
                                >
                                  -
                                </button>
                              )}
                            </div>
                          )
                        )}
                      </>
                    )}
                  </>
                )}
              {(field.type === "text" ||
                field.type === "number" ||
                field.type === "date") && (
                <input
                  id={field.name}
                  type={field.type === "number" ? "text" : field.type}
                  value={formData[field.name] ?? ""}
                  placeholder={field.placeholder}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (field.type === "number") {
                      // permite apenas números, ponto e vírgula
                      value = value.replace(/[^0-9.,]/g, "");
                    }

                    handleChange(field.name, value);
                  }}
                  required={field.required}
                  />
                )}

              {/* MEDIDOR DE GASOLINA */}

              {field.type === "fuel" && (
                <FuelGauge
                  value={formData[field.name] ?? 50}
                  onChange={(value) => handleChange(field.name, value)}
                /> 
              )}

            </Styled.FormGroup>
          ))}

          <Styled.ButtonGroup>

            <button
              type="button"
              className="cancel"
              onClick={onCancel}
            >
              {cancelLabel}
            </button>

            <button
              type="submit"
              className="submit"
            >
              {submitLabel}
            </button>

          </Styled.ButtonGroup>

        </Styled.Form>

      </Styled.ModalContent>
    </Styled.Container>
  );
};

export default ComponentForm;